import React from "react"

import {IonCol, IonGrid, IonRow} from "@ionic/react"

import {PersonGroup as ItemType} from "../../types/PersonGroup"

import ViewHeader           from "./View/Header"
import ViewItemGroupInfo    from "./View/ItemGroupInfo"
import ViewItemGroupLinked  from "./View/ItemGroupLinked"
import ViewItemDataSource   from "./View/ItemDataSource"

export interface formProps {
    item: ItemType
}

const View: React.FC<formProps> = ({ item }) => {

    const formButtons = () => {
        // if (item !== undefined) {
        //     return (<>
        //         {item.options?.isDeletable && <FormButtonDelete item={item} />}
        //     </>)
        // }

        return <div></div>
    }

    return (
        <div className="ion-text-center">
            <ViewHeader        item={item} />
            <ViewItemGroupInfo item={item} />
            {(item.dataSourceId && item.sourceItemId) &&
                <ViewItemDataSource item={item} />
            }
            <ViewItemGroupLinked item={item} />

            <IonGrid className="ion-margin-top">
                <IonRow>
                    <IonCol className="ion-text-right">
                        {formButtons()}
                    </IonCol>
                </IonRow>
            </IonGrid>
        </div>
    )
}

export default View